
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residencies-fellowships/[slug]",
      function () {
        return require("private-next-pages/residencies-fellowships/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residencies-fellowships/[slug]"])
      });
    }
  